import { combineReducers } from 'redux';
import patientReducer from './patientReducer';

const rootReducer = combineReducers({
  patient: patientReducer
  // Add other reducers if needed
});

export default rootReducer;
